<sui-dialog-simple [(error)]="apiError">
  <ng-template suiDialogHeader>
    <fa-icon [icon]="actionIcon"></fa-icon>
    <h2 ngpDialogTitle>{{ dialogTitle }}</h2>

    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogContent>
    <div class="info-text">
      {{
        "import-users-popup.label.the-csv-or-excel-file-must-have-only-the-following-columns:-user,-display-name,-email-and-default-role"
          | translate
      }}
    </div>

    @if (formProperties.length > 0) {
      <app-dynamic-form
        [formProperties]="formProperties"
        [formGroup]="formGroup"
        [fieldFilterString]="searchString"
      ></app-dynamic-form>
    }

    <div class="download-box">
      <a class="download-template" [href]="templateUrl" [download]="fileName">
        <fa-icon [icon]="['fas', 'file-excel']" />
        <span>
          {{ "import-users-popup.label.download-import-temtplate" | translate }}
        </span>
      </a>
    </div>
  </ng-template>

  <ng-template suiDialogFooter>
    <sui-button size="md" variant="secondary" (click)="cancel()">
      {{ "btn.cancel" | translate }}
    </sui-button>
    <sui-button
      size="md"
      variant="primary"
      [leadingIcon]="['fas', 'file-import']"
      [disabled]="!isValid()"
      (click)="save()"
    >
      {{ "btn.import-users" | translate }}
    </sui-button>
  </ng-template>
</sui-dialog-simple>
